import type { Action, Mutation } from 'vuex'

import actionTypes from '../constants/actionTypes'

interface State {
  pdfURL: string
  previewActived: boolean
}

const state = (): State => ({
  pdfURL: '',
  previewActived: false,
})

const actions: { [actionTypes: string]: Action<State, any> } = {
  [actionTypes.SET_PDF_PREVIEW_URL]: ({ commit }, url: string): void => {
    commit(actionTypes.SET_PDF_PREVIEW_URL, url)
  },

  [actionTypes.SET_PDF_PREVIEW_ACTVIE_STATUS]: ({ commit }, status: boolean): void => {
    commit(actionTypes.SET_PDF_PREVIEW_ACTVIE_STATUS, status)
  },
}

const mutations: { [actionTypes: string]: Mutation<State> } = {
  [actionTypes.SET_PDF_PREVIEW_URL]: (state: State, url: string): void => {
    state.pdfURL = url
  },

  [actionTypes.SET_PDF_PREVIEW_ACTVIE_STATUS]: (state: State, status: boolean): void => {
    state.previewActived = status
  },
}

export { State }
export default { namespace: true, actions, state, mutations }
